import { Component } from '@angular/core';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent {
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  cookiePopupVisibility: boolean = false;
  customCookiePopupVisibility: boolean = false;

  constructor(private sizedetection: ResizeDetectionService) {}

  ngOnInit() {
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
        this.isDesktop = data.isDesktop;
        this.isTablet = data.isTablet;
        this.isMobile = data.isMobile;
    });
    if (localStorage.getItem('cookie')) {
        this.cookiePopupVisibility = false;
    } else this.cookiePopupVisibility = true;
  }

  acceptCookie() {
      localStorage.setItem('cookie', "1");
      this.cookiePopupVisibility = false;
  }
  customizeCookie() {
      this.cookiePopupVisibility = false;
      this.customCookiePopupVisibility = true;
  }
  rejectCookie() {
      this.cookiePopupVisibility = false;
  }
  acceptCookieOpen() {
      localStorage.setItem('cookie', "1");
      this.customCookiePopupVisibility= false;
  }
  customizeCookieOpen() {
      localStorage.setItem('cookie', "1");
      this.customCookiePopupVisibility = false;
  }
  rejectCookieOpen() {
      this.customCookiePopupVisibility = true;
  }
}
